import { render } from "./_hot-material-item.vue?vue&type=template&id=feed0a18&scoped=true"
import script from "./_hot-material-item.vue?vue&type=script&lang=js"
export * from "./_hot-material-item.vue?vue&type=script&lang=js"

import "./_hot-material-item.vue?vue&type=style&index=0&id=feed0a18&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feed0a18"]])

export default __exports__